<template>
  <div class="page__wrapper">
    <div
      v-if="svgMap.length > 0"
      class="container-static"
    >
      <map-item-view
        v-for="(itemMap, index) in svgMap"
        :key="`map_${index}`"
        :id="`map_${index}`"
        :ref="`mapRef_${index}`"
        :start-stand-id="showStandId"
        :map="itemMap"
        @click-stand="clickStand"
      />
    </div>
    <div
      v-if="standProps"
      class="participant-info__wrapper"
    >
      <div class="participant-info">
        <button
          @click="closeStandProps()"
          class="close-btn"
        >
          <i class="exu-x-close" />
        </button>
        <div class="participant-logo">
          <img
            :alt="`${standProps.name}-logo`"
            :src="standProps.logo"
          >
        </div>
        <div class="participant-about">
          <span class="participant-about-stand">Стенд {{ standProps.stand }}</span>
          <span class="participant-about-company">{{ standProps.name }}</span>
          <router-link
            :to="{ name: 'exhibitorProfile', params: { id: standProps.id } }"
            class="participant-link"
          >
          Подробнее <i class="exu-chevron-right" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import appBaseNav from '@/components/mixins/appBaseNav';
import methodsmap from '@/components/mixins/apiMethodsMap';
import methodsExhibitors from '@/components/mixins/methodsExhibitors';
import MapItemView from '@/views/pages/MapView/MapItem.vue';

export default {
  name: 'MapPageView',
  mixins: [appBaseNav, methodsmap, methodsExhibitors],
  props: {
    stand_id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      titleMap: null,
      svgMap: [],

      standsList: [],
      standInfo: [],

      fontsList: new Set(),

      showStand: null,
      standProps: null,
    };
  },
  components: { MapItemView },
  computed: {
    showStandId() {
      return this.showStand || this.stand_id;
    },
  },
  mounted() {
    this.$store.commit('setPageTitle', 'Схема');
    this.loadPage();
    if (this.stand_id) {
      this.clickStand(this.stand_id);
    }
  },
  methods: {
    loadPage() {
      console.log('loadPage');
      this.getMap()
        .then((data) => {
          if (data && data.length) {
            this.svgMap = [...data];
            for (let i = 0; i < this.svgMap.length; i += 1) {
              // this.svgMapWidth.push(100);
              this.standInfo.push(null);

              if (data[i].font_link && !this.fontsList.has(data[i].font_family)) {
                this.updateFonts(data[i].font_link);
                this.fontsList.add(data[i].font_family);
              }
            }
          }
        });
    },
    updateFonts(fontLink) {
      const link = document.createElement('link');
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('type', 'text/css');
      link.setAttribute('href', fontLink);
      document.head.appendChild(link);
    },
    clickStand(stand) {
      console.log(stand);
      this.closeStandProps();
      this.standsList.forEach((itemStand) => {
        itemStand.classList.remove('active');
      });

      const standID = stand.replace('stand-', '');
      this.getExhibitorByStand(standID)
        .then((data) => {
          if (data) {
            this.showStand = standID;
            this.standProps = {
              stand: standID,
              ...data,
            };
          } else if (this.$refs.mapRef_0[0].emptyStand) {
            this.$refs.mapRef_0[0].emptyStand(stand);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    closeStandProps() {
      if (this.$refs.mapRef_0 && this.$refs.mapRef_0[0].clearHighlight && this.standProps) {
        this.$refs.mapRef_0[0].clearHighlight();
      }
      this.standProps = null;
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  &__wrapper {
    height: 100%;
  }
}
.container-static {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: [start] 1fr [end];
  grid-template-rows: [start]  1fr [bottomSeparateLine] auto [end];
  position: relative;
  overflow: hidden;
}
.participant {
  &-info {
    &__wrapper {
      position: sticky;
      bottom: 10px;
      grid-column: [start] / [end];
      grid-row: bottomSeparateLine / [end];
    }
    position: relative;
    display: flex;
    gap: 5px;
    color: #1c1c1c;
    background: #fefefe;
    box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.25);
    padding: 4px;
    border-radius: 5px;

    .close-btn {
      position: absolute;
      top: 2px;
      right: 2px;
      width: 16px;
      height: 16px;
      font-size: 16px;
      border: none;
      background: transparent;
      padding: 0;
      color: #AFB0B6;
    }
  }
  &-logo {
    flex: 0 0 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 5px;
    & > img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  &-about {
    flex: 1 1 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    &-stand {
      font-size: 1rem;
      font-weight: 600;
    }
    &-company {
      font-size: 1rem;
      line-height: 1.2em;
      font-weight: 400;
    }
  }
  &-about &-link {
    display: flex;
    justify-content: end;
    align-items: center;
    margin-top: .5rem;
    font-size: .9rem;
    color: #e62d86;
    text-decoration: none;

    & i {
      font-size: 1.1em;
    }
  }

  @media (min-width: 360px) {
    &-info {
      &__wrapper {
        gap: 15px;
      }
    }
    &-logo {
      @media (min-width: 360px) {
        flex: 0 0 100px;
      }
    }
  }
}
</style>
